
export default {
  setRateSheetDefinitions (state, rateSheetDefinitions) {
    state.rateSheetDefinitions = rateSheetDefinitions
  },

  setRateSheetDefinitionsLoading (state, loading) {
    state.rateSheetDefinitionsLoading = loading
  },

  setVersionedRateSheetDefinitions (state, versionedRateSheetDefinitions) {
    state.versionedRateSheetDefinitions = versionedRateSheetDefinitions
  },

  setVersionedRateSheetDefinitionsLoading (state, loading) {
    state.versionedRateSheetDefinitionsLoading = loading
  }
}
